import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
    textField:{
        marginRight: theme.spacing(2),
        width: '100%',
    },
    grid:{
        paddingRight: theme.spacing(2),
        marginTop: prop => prop?.marginTop ? prop.marginTop : '2%',
        minWidth: prop => prop?.width ? prop.width : '25%',
        display: 'inline-block',
        '@media (max-width:1200px)':{
            width: '33%',
        },
        '@media (max-width:992px)':{
            width: '50%',
			marginTop: prop => prop?.marginTop ? prop.marginTop : '2.5%',
        },
        '@media (max-width:768px)':{
            width: '100%',
            marginTop: prop => prop?.marginTop ? prop.marginTop : '3.5%',
        },
    },
}));